/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectList_itemSearch$ref = any;
export type SbSharedRefineMenuFilterStyle_itemSearch$ref = any;
export type SbSharedRefineMenuFilterStyle_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectList_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterStyle_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterStyle_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectList_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'a10949a6fd8ba751f4c7bbdbe059d77f';
export default node;
